import React from "react";
import ContentContainer from "components/Container";

export const IFrame = ({ children }) => {
  return <ContentContainer data-testid="tos-iframe">{children}</ContentContainer>;
};
